<template>
  <div>
    <v-container>
      <div>
        <date-filter
          @changeDate="getData"
          :defaultFilter="'today'"
          v-model="selectedDate"
        ></date-filter>
      </div>
      <div class="mt-3">
        <div class="title mb-3">จำนวนการส่งขอประเมินจากลูกค้า</div>
        <v-card style="width: 300px" class="mx-auto">
          <div class="pa-3 text-xs-center">
            <v-progress-circular
              style="margin-top: 29.2px; margin-bottom: 17.52px; height: 48px"
              v-if="loading"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <h3 v-else>{{ total | numberFormat }}</h3>
          </div>
        </v-card>
        <v-pagination
          class="mt-2"
          :total-visible="15"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>
        <v-data-table
          v-bind:pagination.sync="pagination"
          :headers="headers"
          :items="items"
          class="elevation-1"
          hide-actions
          :loading="loading"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-center">
                <div style="white-space: nowrap">
                  {{ props.item.refid }}
                </div>
              </td>
              <td class="text-xs-center">
                <div>{{ props.item.shopname ? props.item.shopname : '-' }}</div>
              </td>
              <td class="text-xs-left py-2">
                <div v-for="(item, k) in props.item.productlist" :key="k">
                  <span style="white-space: nowrap">
                    {{ item.sales_text_th }} {{ item.size }} x {{ item.quantity }}
                  </span>
                  <v-divider v-if="k !== props.item.productlist.length - 1"></v-divider>
                </div>
              </td>
              <td class="text-xs-center">
                <div>{{ props.item.status ? statusCustom(props.item.status).text : '-' }}</div>
              </td>
              <td class="text-xs-center">
                <div>
                  {{
                    props.item.timestamp
                      ? moment(props.item.timestamp).format('DD/MM/YYYY HH:mm')
                      : '-'
                  }}
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-container>
    <div v-if="showImage">
      <Tinybox v-model="index" :images="currentImages" loop />
    </div>
  </div>
</template>

<script>
import api from '@/api'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Tinybox from 'vue-tinybox'
export default {
  components: {
    DateFilter,
    Tinybox
  },
  data() {
    return {
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      items: [],
      currentImages: [],
      showImage: false,
      index: null,
      loading: false,
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      pagination: { sortBy: 'none', descending: true, rowsPerPage: 25 },
      data: [],
      headers: [
        { text: 'ชื่อลูกค้า', value: 'refid', align: 'center', width: '1%' },
        { text: 'ชื่อร้านค้า', value: 'shopname', align: 'center', width: '1%' },
        { text: 'รายละเอียดสินค้า', value: 'productlist', align: 'center', width: '3%' },
        { text: 'สถานะ', value: 'status', align: 'center', width: '1%' },
        { text: '', value: 'timestamp', align: 'center', width: '1%' }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    moment() {
      return moment
    },
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    }
  },
  async mounted() {
    await this.getData()
  },
  methods: {
    statusCustom(status) {
      switch (status) {
        case 'open':
          return { text: 'ส่งคำขอใบประเมินราคา' }
        case 'accept':
          return { text: 'ส่งใบประเมินราคา' }
        case 'waitingforconfirm':
          return { text: 'รอยืนยันการชำระเงิน' }
        case 'paid':
          return { text: 'ชำระเงินเรียบร้อย' }
        case 'expired':
          return { text: 'เกินกำหนดการชำระเงิน' }
        case 'shipping':
          return { text: 'จัดส่งสินค้า' }
        default:
          return {
            text: status
          }
      }
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData()
      }
    },
    showImageWork(images) {
      this.currentImages = images
      this.showImage = true
      this.index = 0
    },
    getData() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          datefrom: moment(this.selectedDate.start).format('YYYY-MM-DD'), // YYYY-MM-DD
          dateto: moment(this.selectedDate.end).format('YYYY-MM-DD'), // YYYY-MM-DD
          limit: this.limit,
          offset: this.offset
        }
        this.loading = true
        api.customerrequestquotationdashboard(data, (err, response) => {
          this.loading = false
          this.items = response.data.map((el) => {
            try {
              var productlist = JSON.parse(el.productdetail)
              productlist = productlist.productlist
            } catch (error) {
              var productlist = []
            }
            return { ...el, productlist }
          })
          this.total = response.total
          resolve()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toa/Dealer/customerrequestquotation.vue